import http from '@/api/http'

export default {
    getActiveList(cb, form) {
        http.get('/api/banner/getActiveBannerList', cb, form)
    },
    getActiveListLogo(cb, form) {
        http.get('/api/logo/getActiveLogoList', cb, form)
    },
}